import rg4js from 'raygun4js';
import { isProduction, env } from '@/utils/shared/env';
import type { User } from './types';

export function initializeRaygun(): void {
    if (!isProduction) return;

    rg4js('apiKey', env.VITE_RAYGUN_API_KEY);
    rg4js('enableCrashReporting', true);
    rg4js('enableRealUserMonitoring', true);
}

export function setRaygunUser(user: User): void {
    if (!isProduction) return;

    rg4js('setUser', {
        identifier: user.id,
        isAnonymous: false,
        realm: user.realm,
    });
}

export function clearRaygunUser(): void {
    if (!isProduction) return;

    rg4js('setUser', {
        isAnonymous: true,
    });
}
